<template>
<div class="flex justify-center transition">
    <div class="max-w-sm rounded overflow-hidden shadow-2xl flex flex-col mb-2">
        <div class="result p-6  justify-start" v-if="Object.keys(result).length > 0">
            <img class="w-full"
            :src="'https://image.tmdb.org/t/p/w500/' + result.poster_path"  alt="{{ result.title }}"/>
            <h5 class="text-gray-900  text-center text-xl font-medium mb-2 tracking-wide">{{ result.title }}</h5>
            <p class="text-gray-800 text-base"> {{ result.overview }} </p> 
            <p class="text-slate-900 text-base text-center uppercase font-bold">Year: {{ result.release_date.substring(0, 4) }} </p>
        </div>
                    <div class="mt-auto">
                        <button @click="getList"
                            class="w-full bg-slate-700 hover:bg-slate-900 text-white font-bold py-2 px-4 border-b-4  rounded cursor-cell">
                            <i class="fa-solid fa-dice"></i> Randomize </button>
                    </div>
    </div>
</div> 

</template>
<script>
import axios from 'axios';

function randomizerMov(data) {
    if (!data || !Array.isArray(data)) {
        return null;
    }

    // Flatten the array of arrays into a single array
    const flattenedData = data.flat();

    if (flattenedData.length > 0) {
        return flattenedData[Math.floor(Math.random() * flattenedData.length)];
    }
    return null;
}

export default {
    name: 'YourMovie',
    data() {
        return {
            api_key: process.env.VUE_APP_API_KEY,
            url_base: process.env.VUE_APP_API_URL,
            result: {}
        }
    },
    methods: {
        async getList() {
            try {
                const urlOne = `${process.env.VUE_APP_API_URL}/list/8231045?api_key=${process.env.VUE_APP_API_KEY}&page=1`;
                const urlTwo = `${process.env.VUE_APP_API_URL}/list/8231045?api_key=${process.env.VUE_APP_API_KEY}&page=2`;
                const urlThree = `${process.env.VUE_APP_API_URL}/list/8231045?api_key=${process.env.VUE_APP_API_KEY}&page=3`;
                const urlFour = `${process.env.VUE_APP_API_URL}/list/8231045?api_key=${process.env.VUE_APP_API_KEY}&page=4`;
                const urlFive = `${process.env.VUE_APP_API_URL}/list/8231045?api_key=${process.env.VUE_APP_API_KEY}&page=5`;

                const resp1 = await axios.get(urlOne);
                const resp2 = await axios.get(urlTwo);
                const resp3 = await axios.get(urlThree);
                const resp4 = await axios.get(urlFour);
                const resp5 = await axios.get(urlFive);

                const data1 = resp1.data.results;
                const data2 = resp2.data.results;
                const data3 = resp3.data.results;
                const data4 = resp4.data.results;
                const data5 = resp5.data.results;

                this.result = randomizerMov([data1, data2, data3, data4, data5]);
            } catch (error) {
                console.error(error);
            }
        }
    }
}
</script>
